import ExceptionsHandler from './exceptions/handler'

const configureExceptions = () => {
  ExceptionsHandler.init()
}

export default configureExceptions